var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"app-wrapper",attrs:{"id":"layout-container"}},[_c('el-header',{staticClass:"layout-nav",style:({'background-color': this.$store.getters.theme})},[_c('NavMenu')],1),_c('el-container',{staticClass:"body-container"},[_c('el-main',{staticStyle:{"padding":"0"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }